export default "__VITE_ASSET__33a04c9b__"